module.exports = __webpack_public_path__ + "static/media/ic-location.f2d2e1de.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/ic-location.svg
// module id = 636
// module chunks = 14